function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
export var isTouch = function() {
    /* global DocumentTouch */ if ('ontouchstart' in window || window.DocumentTouch && _instanceof(document, DocumentTouch)) return true;
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    return window.matchMedia([
        '(',
        prefixes.join('touch-enabled),('),
        'heartz',
        ')'
    ].join('')).matches;
};
export var isMobile = function() {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
};
export var isIOS = function() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};
export var isAndroid = function() {
    return /Android/i.test(navigator.userAgent);
};
export var isIPhone = function() {
    return /iPhone|iPod/i.test(navigator.userAgent);
};
export var isIPad = function() {
    return /iPad/i.test(navigator.userAgent);
};
